import {
  getListingRepricerDetailsApi,
  updateListingRepricerApi,
  getRepricerStatusCountsApi,
  bulkUpdateListingsApi,
  getRepricerProcessStatusApi,
} from './listing-repricer.api';

import {
  getRepricerSettingsApi,
  updateRepricerSettingsApi,
  runRepricerApi,
  resetCompletedListingsApi,
  getStoreRepricerSettingsApi,
  updateStoreRepricerSettingsApi,
  getRepricerListingsApi,
} from './listing-repricer.api';

// Settings reducers
export const repricerSettingsReducers = (builder) => {
  builder
    .addCase(getRepricerSettingsApi.pending, (state) => {
      state.getRepricerSettingsStatus = 'pending';
    })
    .addCase(getRepricerSettingsApi.fulfilled, (state, { payload }) => {
      state.getRepricerSettingsStatus = 'fulfilled';
      state.settings = payload;
    })
    .addCase(getRepricerSettingsApi.rejected, (state, action) => {
      state.getRepricerSettingsStatus = 'rejected';
      state.error = action?.error?.message;
    });
};

export const updateRepricerSettingsReducers = (builder) => {
  builder
    .addCase(updateRepricerSettingsApi.pending, (state) => {
      state.updateRepricerSettingsStatus = 'pending';
    })
    .addCase(updateRepricerSettingsApi.fulfilled, (state, { payload }) => {
      state.updateRepricerSettingsStatus = 'fulfilled';
      state.settings = payload;
    })
    .addCase(updateRepricerSettingsApi.rejected, (state, action) => {
      state.updateRepricerSettingsStatus = 'rejected';
      state.error = action?.error?.message;
    });
};

// Run optimization reducers
export const runRepricerReducers = (builder) => {
  builder
    .addCase(runRepricerApi.pending, (state) => {
      state.runRepricerStatus = 'pending';
      state.isRepricerRunning = true;
    })
    .addCase(runRepricerApi.fulfilled, (state, { payload }) => {
      state.runRepricerStatus = 'fulfilled';
      state.isRepricerRunning = false;
      state.lastRepricerResult = payload;
    })
    .addCase(runRepricerApi.rejected, (state, action) => {
      state.runRepricerStatus = 'rejected';
      state.isRepricerRunning = false;
      state.error = action?.error?.message;
    });
};

// Reset completed listings reducers
export const resetCompletedListingsReducers = (builder) => {
  builder
    .addCase(resetCompletedListingsApi.pending, (state) => {
      state.resetCompletedListingsStatus = 'pending';
    })
    .addCase(resetCompletedListingsApi.fulfilled, (state) => {
      state.resetCompletedListingsStatus = 'fulfilled';
    })
    .addCase(resetCompletedListingsApi.rejected, (state, action) => {
      state.resetCompletedListingsStatus = 'rejected';
      state.error = action?.error?.message;
    });
};

// Store optimizer settings reducers
export const storeRepricerSettingsReducers = (builder) => {
  builder
    .addCase(getStoreRepricerSettingsApi.pending, (state) => {
      state.getStoreRepricerSettingsStatus = 'pending';
    })
    .addCase(getStoreRepricerSettingsApi.fulfilled, (state, { payload }) => {
      state.getStoreRepricerSettingsStatus = 'fulfilled';
      state.storeRepricerSettings = payload;
    })
    .addCase(getStoreRepricerSettingsApi.rejected, (state, action) => {
      state.getStoreRepricerSettingsStatus = 'rejected';
      state.error = action?.error?.message;
    })
    .addCase(updateStoreRepricerSettingsApi.pending, (state) => {
      state.updateStoreRepricerSettingsStatus = 'pending';
    })
    .addCase(updateStoreRepricerSettingsApi.fulfilled, (state, { payload }) => {
      state.updateStoreRepricerSettingsStatus = 'fulfilled';
      state.storeRepricerSettings = payload;
    })
    .addCase(updateStoreRepricerSettingsApi.rejected, (state, action) => {
      state.updateStoreRepricerSettingsStatus = 'rejected';
      state.error = action?.error?.message;
    });
};

// Optimization listings reducers
export const repricerListingsReducers = (builder) => {
  builder
    .addCase(getRepricerListingsApi.pending, (state) => {
      state.getRepricerListingsStatus = 'pending';
    })
    .addCase(getRepricerListingsApi.fulfilled, (state, { payload }) => {
      state.getRepricerListingsStatus = 'fulfilled';
      state.listings = payload.listings;
      state.listingsTotalCount = payload.totalCount;
      state.listingsCurrentPage = payload.currentPage;
      state.listingsTotalPages = payload.totalPages;
    })
    .addCase(getRepricerListingsApi.rejected, (state, action) => {
      state.getRepricerListingsStatus = 'rejected';
      state.error = action?.error?.message;
    });
};

// Get listing optimization details reducers
export const getListingRepricerDetailsReducers = (builder) => {
  builder
    .addCase(getListingRepricerDetailsApi.pending, (state) => {
      state.getListingRepricerDetailsStatus = 'pending';
    })
    .addCase(getListingRepricerDetailsApi.fulfilled, (state, { payload }) => {
      state.getListingRepricerDetailsStatus = 'fulfilled';
      state.selectedListingDetails = payload;
    })
    .addCase(getListingRepricerDetailsApi.rejected, (state, action) => {
      state.getListingRepricerDetailsStatus = 'rejected';
      state.error = action?.error?.message;
    });
};

export const bulkUpdateListingsReducers = (builder) => {
  builder
    .addCase(bulkUpdateListingsApi.pending, (state) => {
      state.bulkUpdateStatus = 'pending';
    })
    .addCase(bulkUpdateListingsApi.fulfilled, (state, { payload }) => {
      state.bulkUpdateStatus = 'fulfilled';
      state.bulkUpdateResult = payload;
    })
    .addCase(bulkUpdateListingsApi.rejected, (state, action) => {
      state.bulkUpdateStatus = 'rejected';
      state.error = action?.error?.message;
    });
};

export const processStatusReducers = (builder) => {
  builder
    .addCase(getRepricerProcessStatusApi.pending, (state) => {
      state.processStatusLoading = 'pending';
    })
    .addCase(getRepricerProcessStatusApi.fulfilled, (state, { payload }) => {
      state.processStatusLoading = 'fulfilled';
      state.isRepricerRunning = payload.isRunning;
      state.processStatus = payload;
    })
    .addCase(getRepricerProcessStatusApi.rejected, (state, action) => {
      state.processStatusLoading = 'rejected';
      state.error = action?.error?.message;
    });
};

// Update listing optimization reducers
export const updateListingRepricerReducers = (builder) => {
  builder
    .addCase(updateListingRepricerApi.pending, (state) => {
      state.updateListingRepricerStatus = 'pending';
    })
    .addCase(updateListingRepricerApi.fulfilled, (state, { payload }) => {
      state.updateListingRepricerStatus = 'fulfilled';
      // Update the specific listing in the listings array
      const listingIndex = state.listings.findIndex(
        (listing) => listing._id === payload._id,
      );
      if (listingIndex !== -1) {
        state.listings[listingIndex] = { ...state.listings[listingIndex], ...payload };
      }
    })
    .addCase(updateListingRepricerApi.rejected, (state, action) => {
      state.updateListingRepricerStatus = 'rejected';
      state.error = action?.error?.message;
    });
};

// Get optimization status counts reducers
export const getRepricerStatusCountsReducers = (builder) => {
  builder
    .addCase(getRepricerStatusCountsApi.pending, (state) => {
      state.getRepricerStatusCountsStatus = 'pending';
    })
    .addCase(getRepricerStatusCountsApi.fulfilled, (state, { payload }) => {
      state.getRepricerStatusCountsStatus = 'fulfilled';
      state.statusCounts = payload;
    })
    .addCase(getRepricerStatusCountsApi.rejected, (state, action) => {
      state.getRepricerStatusCountsStatus = 'rejected';
      state.error = action?.error?.message;
    });
};
